@if (sheet_ready) {
  <series-sheet-view (refreshInner)="onSheetRefresh()" [process]="process"
  [series]="series" [seriesComponents]="seriesComponents"></series-sheet-view>
}
